import { render, staticRenderFns } from "./crud_designations.vue?vue&type=template&id=9b4ea472&scoped=true"
import script from "./crud_designations.vue?vue&type=script&lang=js"
export * from "./crud_designations.vue?vue&type=script&lang=js"
import style0 from "./crud_designations.vue?vue&type=style&index=0&id=9b4ea472&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4ea472",
  null
  
)

export default component.exports